export var APP_ENV = process.env.REACT_APP_ENV;
export var __DEBUG__ = APP_ENV !== 'production';
export var DEFAULT_LANGUAGE = 'nl';
export var SITE_NAME = 'Unc Inc';
var API_URL = 'https://content.uncinc.nl';
if (APP_ENV === 'development') {
  API_URL = 'http://uncinc.docker.localhost';
} else if (APP_ENV === 'staging') {
  API_URL = 'https://staging.uncinc.nl';
}
export var IS_SERVER = !(typeof window !== 'undefined' && window.document && window.document.createElement);
export var IS_CLIENT = !IS_SERVER;

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/shared/styles/assets/_variables.scss'.
export var SCREEN_MOBILE = 0;
export var SCREEN_TABLET = 768;
export var SCREEN_NORMAL = 992;
export var SCREEN_WIDE = 1240;
export var SCREEN_HUGE = 2000;
export var VIEW_ACTION_REPLACE = 'replace';
export var VIEW_ACTION_APPEND = 'append';
export { API_URL };